export default "__VITE_ASSET__Bfzg9dVi__"